export default [
  {
    path: '/Project',
    component: () => import('@/views/ProjectPage'),
    name: 'Project',
    meta: {
      title: '用户中心',
      leavl: 0
    },
    children: [
      // 用户管理
      {
        path: '/Project/UserManagement',
        name: 'UserManagement',
        meta: {
          title: '用户管理'
        },
        component: () => import('@/views/ProjectPage/UserManagement')
      },
      // 部门管理
      {
        path: '/Project/DepartmentManagement',
        name: 'DepartmentManagement',
        meta: {
          title: '部门管理'
        },
        component: () => import('@/views/ProjectPage/DepartmentManagement')
      },
      // 菜单管理
      {
        path: '/Project/MenuManagement',
        name: 'MenuManagement',
        meta: {
          title: '菜单管理'
        },
        component: () => import('@/views/ProjectPage/MenuManagement')
      },
      // 角色管理
      {
        path: '/Project/RoleManagement',
        name: 'RoleManagement',
        meta: {
          title: '角色管理'
        },
        component: () => import('@/views/ProjectPage/RoleManagement')
      },
      // 系统管理
      {
        path: '/Project/SystemManagement',
        name: 'SystemManagement',
        meta: {
          title: '系统管理'
        },
        component: () => import('@/views/ProjectPage/SystemManagement')
      },
      // 接口管理
      {
        path: '/Project/Authority',
        name: 'Authority',
        meta: {
          title: '接口管理'
        },
        component: () => import('@/views/ProjectPage/AuthorityManagement/index'),
        children: [
          {
            path: 'AuthorityManagement',
            name: 'AuthorityManagement',
            meta: {
              title: '接口管理'
            },
            component: () => import('@/views/ProjectPage/AuthorityManagement/AuthorityManagement')
          },
          {
            path: 'Rule',
            name: 'Rule',
            meta: {
              title: '接口规则'
            },
            component: () => import('@/views/ProjectPage/AuthorityManagement/AuthorityManagementRule')
          }
        ]
      }
      // {
      //   path: '/Project/AuthorityManagementRule',
      //   name: 'AuthorityManagementRule',
      //   component: () => import('@/views/ProjectPage/AuthorityManagement/AuthorityManagementRule')
      // }
    ]
  }
]
